module.exports = __webpack_public_path__ + "static/media/CYNET LOGO-white.8bd4ce83.svg";